// utils/request.js
import axios from 'axios';
import { Message, Loading } from 'element-ui';
import { getAccessToken } from './token';
import { handle401Error } from './refreshToken';

let loadingInstance = null;

const options = {
  fullscreen: true,
  target: ''
};

const Axios = axios.create({
  timeout: 50000,
  withCredentials: true,
  responseType: 'json',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': 'Basic c2FiZXI6c2FiZXJfc2VjcmV0'
  }
});

// 请求拦截器
Axios.interceptors.request.use(config => {
  const token = getAccessToken();
  if (token) {
    config.headers['blade-auth'] = `bearer ${token}`;
  }

  // 判断是否需要 loading,默认打开
  const isLoadingEnabled = config.loading !== false;
  if (isLoadingEnabled) {
    options.target = typeof config.loading === 'string' ? config.loading : document.body;
    loadingInstance = Loading.service(options);
  }

  return config;
}, error => {
  if (loadingInstance) loadingInstance.close();
  return Promise.reject(error);
});

// 响应拦截器
Axios.interceptors.response.use(
  async response => {
    if (loadingInstance) loadingInstance.close();
    if (response.config.responseType === 'blob') {
      return response;
    }
    const res = response.data;

    if (res.code === 200) {
      return res;
    }

    if (response.config.url.includes('/hightedSubject')) {
      return res; 
    }

    if (res.code === 401) {
      const fakeError = {
        config: response.config,
        response: {
          status: 401
        }
      };
      return await handle401Error(fakeError, Axios);
    }

    console.log('接口返回错误信息:', res);
    Message.error(res.msg || '请求失败');
    return Promise.reject(res.msg);
  },
  error => {
    if (loadingInstance) loadingInstance.close();
    console.error('请求异常:', error);
    Message.error(error.message || '网络请求错误');
    return handle401Error(error, Axios);
  }
);

export default Axios;
